import React, {
  SyntheticEvent,
  useState,
  useRef,
  Fragment,
  memo,
  ReactNode,
} from 'react';
import classnames from 'classnames';
import { createUseStyles, useTheme } from 'react-jss';
import { Theme } from '@app/theme';
import { MenuWindow } from './MenuWindow';
import { Button, SpecialProps as ButtonProps } from '../Buttons/Button';

const useStyles = createUseStyles((theme: Theme) => ({
  caret: {
    fontSize: theme.iconSize.regular,
  },
  caretContainer: {
    display: 'inline-flex',
    alignItems: 'center',
    justifyContent: 'center',
    minHeight: theme.height.small,

    width: 28,

    borderLeft: {
      width: 1,
      style: 'solid',
      color: theme.colors.white,
    },
  },
}));

interface Props extends ButtonProps {
  children: React.ReactNode;
  textComponent?: React.ReactNode;
}

export const MenuButton = memo(
  ({ children, textComponent, ...buttonProps }: Props) => {
    const theme: Theme = useTheme();
    const classes = useStyles({ theme });

    const [anchorElmnt, setAnchorElmnt] = useState<null | Element>(null);
    const idRef = useRef(`button_menu_${Math.random()}`);

    const onClick = (event: SyntheticEvent) => {
      event.stopPropagation();
      setAnchorElmnt(event.currentTarget);
    };
    const onClose = (event: SyntheticEvent) => {
      event.stopPropagation();
      setAnchorElmnt(null);
    };

    return (
      <Fragment>
        <Button
          rightInsert={
            <div className={classes.caretContainer}>
              <i
                className={classnames('ri-arrow-down-s-line', classes.caret)}
              />
            </div>
          }
          {...buttonProps}
          children={textComponent}
          onClick={onClick}
          aria-controls={idRef.current}
          aria-haspopup="true"
        />
        <MenuWindow
          open={!!anchorElmnt}
          onClose={onClose}
          id={idRef.current}
          anchorEl={anchorElmnt}
          onClick={onClose}
        >
          {children}
        </MenuWindow>
      </Fragment>
    );
  },
);
